module.exports = __webpack_public_path__ + "static/media/favicon-trw.46343430.svg";